// @flow
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { memo, Fragment } from 'react';
import { BrowserRouter } from 'react-router-dom';
import _ from 'lodash';
import Url from 'url-parse';
import { connect } from 'react-redux';
import { getToken } from 'client/utils/user';
import history from 'client/utils/history';
import logo from './assets/logo.svg';
import Styles from './styles';

type Props = {
  profileData : any,
  preActive? : string,
  verticalMove? : (direction : string) => void,
};

const Navbar = memo(({
  profileData,
  preActive,
  verticalMove,
} : Props) => {
  const { pathname } = Url();

  const handleGoBack = () => {
    if (_.get(window, ['webOS', 'platform', 'tv'])) {
      if (Url(window.location.href).pathname === '/') {
        window.webOS.platformBack();
      } else {
        history.goBack();
      }
    } else {
      history.goBack();
    }
  };

  return (
    <Styles className={`selectableRow${preActive ? ' preActiveRow' : ''}`}>
      <BrowserRouter>
        {/* eslint-disable-next-line */}
        <img
          src={logo}
          className="logo"
          id="logo"
          alt="logo"
          onClick={() => history.push('/')}
        />
        <div className="actions">
          <div className="navbarControlsWrapper">
            {
              (
                (pathname === '/')
                && _.get(window, ['webOS', 'platform', 'tv'])
              ) && (
                <Fragment>
                  <button
                    className="selectableItem"
                    onClick={() => verticalMove && verticalMove('down')}
                    clickable="true"
                  >
                    <i className="fa fa-angle-double-down" />
                  </button>
                  <button
                    className="selectableItem"
                    onClick={() => verticalMove && verticalMove('up')}
                    clickable="true"
                  >
                    <i className="fa fa-angle-double-up" />
                  </button>
                </Fragment>
              )
            }
            {
              (pathname !== '/') &&
              <button
                className="selectableItem"
                onClick={handleGoBack}
                clickable="true"
              >
                <i className="fa fa-angle-left" />
              </button>
            }
            {
              (pathname !== '/search') &&
              <button
                className={`selectableItem${(preActive === 'search') ? ' preActiveItem' : ''}`}
                onClick={() => history.push('/search')}
                clickable="true"
              >
                <i className="fa fa-search" />
              </button>
            }
            {
              (pathname !== '/') &&
              <button
                className={`selectableItem${(preActive === 'home') ? ' preActiveItem' : ''}`}
                onClick={() => history.push('/')}
                clickable="true"
              >
                <i className="fa fa-home" />
              </button>
            }
            {
              !(getToken()) && (pathname !== '/signin') && (
                <button
                  className={`selectableItem loginButton${(preActive === 'signin') ? ' preActiveItem' : ''}`}
                  onClick={() => history.push('/signin')}
                  clickable="true"
                  aria-label="login"
                >
                  <i className="fa fa-user" />
                  <span>ورود</span>
                </button>
              )
            }
            {
              getToken() && (profileData.size > 0) && (
                <div className="navbarUserWrapper">
                  <div className="textWrapper">
                    <p className="user_name">
                      {
                        profileData.getIn(['name']) || `0${profileData.getIn(['mobile'])
                          .substring(2)}`
                      }
                    </p>
                  </div>
                  <button
                    aria-label="profile"
                    className={`${(pathname !== '/profile') ? 'selectableItem' : ''}${(preActive === 'profile') ? ' preActiveItem' : ''}`}
                    onClick={() => history.push('/profile')}
                    clickable="true"
                    disabled={pathname === '/profile'}
                  >
                    {
                      profileData.getIn(['pic_s'])
                        ? <img src={profileData.getIn(['pic_s'])} alt="" />
                        : <i className="fa fa-user" />
                    }
                  </button>
                </div>
              )
            }
          </div>
        </div>
      </BrowserRouter>
    </Styles>
  );
});

export default connect(
  (state : any) => ({
    profileData: state.getIn(['Profile', 'profileData']),
  }),
  {},
)(Navbar);
